export default __webpack_public_path__ + "static/media/sell-postion-2.4c8bafc4.svg";